var React = require('react');

function Ua (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"gold","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#0057b8","d":"M0 0h640v240H0z","key":1})]));
}

Ua.defaultProps = {"id":"flag-icons-ua","viewBox":"0 0 640 480"};

module.exports = Ua;

Ua.default = Ua;
